import { i18n } from "translate/i18n";

export const notAcceptedYet = i18n.t("messages.challenge.notAcceptedYet");
export const checkEmail = i18n.t("messages.challenge.checkEmail");
